import{useState as o}from"react";const r=()=>{const e=o(!1)[1];return()=>e(t=>!t)};export{r as useForceUpdate};
